import { Redirect } from 'expo-router';

export default function KursiPlayCreateLegacyRedirect() {
  return <Redirect href="/learn/path/create" />;
}
